import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { CalibrationId, CalibrationSpeed } from 'services/equipmentSets/types';
import { makeSelectCalibrationSpeed } from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    speed: CalibrationSpeed;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsSpeedListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { speed } = this.props;

        return <ListItem description="Speed" value={`${speed} km/h`} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    speed: makeSelectCalibrationSpeed()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsSpeedListItemComponent
);
